import { ErrorBoundary, Shell } from "@qubit/autoparts";
import { useCallback, useContext, useState } from "react";
import { Outlet } from "react-router";

import EventSimulator from "~/components/debug/EventSimulator";
import envConstants from "~/config/envConstants";
import { Navbar } from "~/features/navbar/Navbar";
import { NavigationDrawer } from "~/features/navigationDrawer/NavigationDrawer";

import { DevCheatsContext } from "~/hooks/useDevCheats";

export function BasicLayout() {
  const [isEventSimulatorOpen, setIsEventSimulatorOpen] = useState(false);

  const { showEventSimulator } = useContext(DevCheatsContext);

  const devCheatClickHandler = useCallback(() => {
    if (envConstants.DEV_CHEATS_UAT !== "true") {
      return;
    }
    if (showEventSimulator) {
      setIsEventSimulatorOpen(!isEventSimulatorOpen);
    }
  }, [isEventSimulatorOpen, showEventSimulator]);

  return (
    <Shell
      AppBar={<Navbar onDevCheatClick={devCheatClickHandler} />}
      Drawer={<NavigationDrawer />}
      sx={{
        "& main": {
          minWidth: 0,
          overflowX: "auto"
        }
      }}
    >
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
      {isEventSimulatorOpen && <EventSimulator />}
    </Shell>
  );
}
